import { courseExerciseStatus } from 'constants/tests';
import { colors } from 'global/colors';

export const getHeightOfContainer = (totalItems) => {
  let height = '';
  switch (totalItems) {
    case 2:
      height = '200px';
      break;
    case 3:
      height = '240px';
      break;
    case 4:
      height = '310px';
      break;
    case 5:
      height = '300px';
      break;
    case 6:
      height = '330px';
      break;
    case 7:
      height = '430px';
      break;
    case 8:
      height = '540px';
      break;
    case 9:
      height = '600px';
      break;
    case 10:
      height = '700px';
      break;
    default:
      break;
  }
  return height;
};

export const getTopCalculation = (totalItems, index) => {
  let top = 0;
  switch (totalItems) {
    case 1:
      top = 0;
      break;
    case 2:
      if (index === 0) top = 0;
      if (index === 1) top = 80;
      break;
    case 3:
      if (index === 0) top = 0;
      if (index === 1) top = 80;
      if (index === 2) top = 120;
      break;
    case 4:
      if (index === 0) top = 0;
      if (index === 1) top = 80;
      if (index === 2) top = 40;
      if (index === 3) top = 120;
      break;
    case 5:
      if (index === 0) top = 0;
      if (index === 1) top = 80;
      if (index === 2) top = 0;
      if (index === 3) top = 80;
      if (index === 4) top = 50;
      break;
    case 6:
      if (index === 0) top = 0;
      if (index === 1) top = 80;
      if (index === 2) top = 0;
      if (index === 3) top = 80;
      if (index === 4) top = 60;
      if (index === 5) top = 120;
      break;
    case 7:
      if (index === 0) top = 0;
      if (index === 1) top = 80;
      if (index === 2) top = 0;
      if (index === 3) top = 80;
      if (index === 4) top = 60;
      if (index === 5) top = 160;
      if (index === 6) top = 220;
      break;
    case 8:
      if (index === 0) top = 0;
      if (index === 1) top = 80;
      if (index === 2) top = 0;
      if (index === 3) top = 80;
      if (index === 4) top = 60;
      if (index === 5) top = 160;
      if (index === 6) top = 260;
      if (index === 7) top = 200;
      break;
    case 9:
      if (index === 0) top = 0;
      if (index === 1) top = 80;
      if (index === 2) top = 0;
      if (index === 3) top = 80;
      if (index === 4) top = 60;
      if (index === 5) top = 160;
      if (index === 6) top = 260;
      if (index === 7) top = 220;
      if (index === 8) top = 260;
      break;
    default:
      break;
  }
  return top;
};

export const getOrderOfLevels = (levelNames) => {
  const columns = [[], [], [], []];
  const itemPlacementOrder = [
    [1],
    [1, 2],
    [1, 2, 3],
    [1, 2, 1, 2],
    [0, 1, 2, 3, 2],
    [0, 1, 2, 3, 2, 1],
    [0, 1, 2, 3, 2, 1, 0],
    [0, 1, 2, 3, 2, 1, 0, 1],
    [0, 1, 2, 3, 2, 1, 0, 1, 2],
    [0, 1, 2, 3, 2, 1, 0, 1, 2, 3],
    [0, 1, 2, 3, 2, 1, 0, 1, 2, 3, 2],
  ];

  let levels = [...levelNames];
  levels.push({ levelName: '', isCompleted: false, isExtraDiv: true });

  const order = itemPlacementOrder[levels.length - 1];

  levels.forEach((level, index) => {
    columns[order[index]].push({ level, index, isExtraDiv: level.isExtraDiv });
  });

  return { levels, columns };
};

export const getColorForIcons = (status) => {
  switch (status) {
    case courseExerciseStatus.CURRENT:
      return colors.lightBlue16;
    case courseExerciseStatus.COMPLETED:
      return colors.green4;
    case courseExerciseStatus.UNLOCKED:
      return colors.lightGray7;
    default:
      return colors.lightGray17;
  }
};

export const getCharacterImages = (items) => {
  switch (items) {
    case 2:
      return { left: 10 };
    case 3:
      return { left: 10 };
    case 4:
      return { right: 10 };
    case 5:
      return { left: 10 };
    case 6:
      return { left: 10 };
    case 7:
      return { left: 10 };
    case 8:
      return { right: 10 };
    case 9:
      return { right: 10 };
    case 10:
      return { left: 10 };
    default:
      return { left: 10 };
  }
};
